import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  /** Heading level for the title, so it fits the outline it sits in. `h1` when it is the whole page. */
  as?: 'h1' | 'h2' | 'h3';
}

export function EmptyState({ icon, title, description, action, as: Heading = 'h3' }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      {icon && (
        <div className="text-secondary mb-4">
          {icon}
        </div>
      )}
      <Heading className="text-lg font-semibold text-base-content mb-1">{title}</Heading>
      {description && (
        <p className="text-sm text-base-content/80 mb-4 max-w-sm">{description}</p>
      )}
      {action && (
        <div className="mt-2">
          {action}
        </div>
      )}
    </div>
  );
}
